import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getWalletsApi, Wallet, WalletResponse } from "./api";
import { State } from "@features/base/types";

export const getWallets = createAsyncThunk<WalletResponse, { userId: string }>(
  "wallets/getWallets",
  async ({ userId }, { rejectWithValue }) => {
    try {
      return await getWalletsApi(userId);
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

type WalletsState = State<{
  wallets: Wallet[] | null;
}>;

const initialState: WalletsState = {
  wallets: null,
  loading: false,
  error: null,
};

const walletsSlice = createSlice({
  name: "wallets",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getWallets.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getWallets.fulfilled, (state, action) => {
        state.loading = false;
        state.wallets = action.payload;
      })
      .addCase(getWallets.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
  },
});

export default walletsSlice.reducer;
